var _excluded = ["datasource", "disableAnimation", "renderItem", "getItemKey", "mode", "draggable", "placeholder", "height", "trigger", "className", "onChange", "onValueChange", "onItemClick", "onDragStart", "onDragging", "onDragEnd", "onDragCancel", "rowHeight"],
    _excluded2 = ["data", "renderItem", "itemKey", "trigger", "style", "domRef", "draggable", "className", "dragNode", "handleDrop", "index"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useRef, useState, useCallback } from 'react';
import { AutoSizer, List as VirtualList } from 'react-virtualized';
import { classnames, getUniqueKey } from '@okee-uikit/react-utils';
import { useCombineRef, useRefCallback } from '@okee-uikit/react-hooks';
import { useDirection, usePrefixCls } from '@okee-uikit/react-config';
import { useChildrenEnterLeave } from '../../hooks/animation';
export function List(props) {
  var datasource = props.datasource,
      _props$disableAnimati = props.disableAnimation,
      disableAnimation = _props$disableAnimati === void 0 ? true : _props$disableAnimati,
      renderItem = props.renderItem,
      _props$getItemKey = props.getItemKey,
      getItemKey = _props$getItemKey === void 0 ? getUniqueKey : _props$getItemKey,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? 'vertical' : _props$mode,
      _props$draggable = props.draggable,
      draggable = _props$draggable === void 0 ? false : _props$draggable,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? 'line' : _props$placeholder,
      height = props.height,
      trigger = props.trigger,
      className = props.className,
      onChange = props.onChange,
      onValueChange = props.onValueChange,
      onItemClick = props.onItemClick,
      onDragStart = props.onDragStart,
      onDragging = props.onDragging,
      onDragEnd = props.onDragEnd,
      onDragCancel = props.onDragCancel,
      _props$rowHeight = props.rowHeight,
      rowHeight = _props$rowHeight === void 0 ? 34 : _props$rowHeight,
      extra = _objectWithoutProperties(props, _excluded);

  var dragNode = useRef();
  var direction = useDirection();
  var cls = classnames(className, usePrefixCls('list', {
    rtl: direction === 'rtl'
  }));
  var containerCls = usePrefixCls('list-container', _defineProperty({}, mode, true));
  var ref = useRef(null);
  var onChangeCallback = useRefCallback(onChange);
  var onValueChangeCallback = useRefCallback(onValueChange);
  var onDrop = useRefCallback(function (node) {
    var data = _toConsumableArray(datasource);

    var removed = typeof dragNode.current === 'undefined' ? [] : data.splice(dragNode.current, 1);
    data.splice.apply(data, [node, 0].concat(_toConsumableArray(removed)));
    onChangeCallback(data);
    onValueChangeCallback(data);
  });
  var children = datasource.map(function (data, index) {
    var key = getItemKey(data);
    return React.createElement(ListItemWrapper, {
      index: index,
      key: key,
      itemKey: key,
      renderItem: renderItem,
      draggable: draggable,
      data: data,
      trigger: trigger,
      dragNode: dragNode,
      handleDrop: onDrop
    });
  });

  var _useChildrenEnterLeav = useChildrenEnterLeave(children, {
    duration: 200,
    childRefKey: null,
    enterTick: function enterTick() {
      return void 0;
    },
    ignoreInitialRender: true,
    skipChildWithoutRef: false,
    disabled: disableAnimation,
    enterChildProps: {
      'data-motion-fade': 'in'
    },
    leaveChildProps: {
      'data-motion-fade': 'out'
    }
  }),
      _useChildrenEnterLeav2 = _slicedToArray(_useChildrenEnterLeav, 2),
      animatedChildren = _useChildrenEnterLeav2[0],
      startAnimation = _useChildrenEnterLeav2[1];

  useEffect(startAnimation);

  var renderVirtualItem = function renderVirtualItem(_ref) {
    var key = _ref.key,
        index = _ref.index,
        style = _ref.style;
    var item = animatedChildren[index];

    var _style = _objectSpread(_objectSpread({}, style), {}, {
      padding: '0 12px',
      boxSizing: 'border-box'
    });

    return React.createElement("div", {
      style: _style,
      key: key,
      onClick: function onClick() {
        return onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(datasource[index]);
      }
    }, item);
  };

  return React.createElement("div", _objectSpread(_objectSpread({}, extra), {}, {
    ref: ref,
    className: cls
  }), React.createElement("div", {
    className: containerCls,
    "data-container-id": "container",
    style: {
      height: height !== null && height !== void 0 ? height : 192,
      padding: '12px 0 4px 0'
    }
  }, React.createElement(AutoSizer, null, function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return React.createElement(VirtualList, {
      width: width,
      height: height,
      rowHeight: rowHeight,
      rowCount: children.length,
      rowRenderer: renderVirtualItem
    });
  })));
}

function ListItemWrapper(props) {
  var data = props.data,
      renderItem = props.renderItem,
      itemKey = props.itemKey,
      trigger = props.trigger,
      style = props.style,
      _props$domRef = props.domRef,
      domRef = _props$domRef === void 0 ? null : _props$domRef,
      _props$draggable2 = props.draggable,
      draggable = _props$draggable2 === void 0 ? false : _props$draggable2,
      className = props.className,
      dragNode = props.dragNode,
      handleDrop = props.handleDrop,
      index = props.index,
      restProps = _objectWithoutProperties(props, _excluded2);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      dragOver = _useState2[0],
      setDragOver = _useState2[1];

  var ref = useRef(null);
  var combinedRef = useCombineRef(ref, domRef);
  var cls = usePrefixCls('list-item-wrapper', {
    draggable: draggable,
    trigger: !trigger,
    'drag-over': dragOver
  });
  var handleDragStart = useCallback(function (e) {
    e.dataTransfer.setDragImage(combinedRef.current, 10, 10);
    typeof index !== 'undefined' && dragNode && (dragNode.current = index);
  }, []);
  var onDrop = useCallback(function () {
    if (draggable) {
      setDragOver(false);
      handleDrop && handleDrop(index);
    }
  }, []);
  var onDragLeave = useCallback(function () {
    setDragOver(false);
  }, []);
  var onDragOver = useCallback(function (e) {
    setDragOver(true);
    e.preventDefault();
  }, []);
  return React.createElement("div", _objectSpread(_objectSpread({
    draggable: draggable,
    onDrop: onDrop,
    onDragStart: handleDragStart,
    onDragOver: onDragOver,
    onDragLeave: onDragLeave
  }, restProps), {}, {
    className: classnames(cls, className),
    ref: combinedRef,
    style: style,
    "data-element-id": itemKey
  }), renderItem(data));
}